var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full header-bottom__search" },
    [
      _c("buyer-input", {
        attrs: { placeholder: "Search", type: "search", value: _vm.value },
        on: {
          input: function($event) {
            return _vm.$emit("search-input", $event)
          },
          search: function($event) {
            return _vm.$emit("perform-search", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }